export default function promiseMiddleware({ dispatch, getState }) {
  return next => action => {
    if (!action) {
      return;
    }
    
    if (typeof action === 'function') {
      return action(dispatch, getState);
    }

    return next(action);
  }
}



// WEBPACK FOOTER //
// ./src/utils/middleware/promiseMiddleware.js